const MAX_FILE_SIZE_MB = 10;
const ALLOWED_FILE_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];

export {MAX_FILE_SIZE_MB, ALLOWED_FILE_TYPES};
